<section class="rounded-lg bg-primary-50 p-4">
  <div class="m-auto flex w-full flex-col gap-2">
    <h4 class="text-primary-900">
      {{ "prestation.airportForm.title" | transloco }}
    </h4>

    @for (
      airport of this.transportFormService.flightStopsControls;
      track airport;
      let i = $index;
      let last = $last
    ) {
      <div
        class="flex flex-row items-start gap-2"
        [class.opacity-50]="draggedIndex === i"
        (dragover)="onDragOver($event)"
        (drop)="onDrop($event, i)"
        (dragend)="onDragEnd()"
      >
        <!-- Drag handle (only the handle is draggable so the autocomplete stays usable) -->
        <div
          class="cursor-move pt-8 text-gray-400 hover:text-gray-600"
          draggable="true"
          (dragstart)="onDragStart($event, i)"
          data-testid="airport-drag-handle"
        >
          <i class="pi pi-bars text-lg"></i>
        </div>

        <app-select-airport
          class="flex flex-1"
          [placeholder]="placeholderFor(i, last)"
          [isTransit]="i > 0 && !last"
          [index]="i"
          [formGroup]="airport"
          (delete)="this.transportFormService.removeAirport(i)"
          [attr.data-testid]="
            i === 0
              ? 'airport-from-input'
              : last
                ? 'airport-to-input'
                : 'airport-transit-input'
          "
        />
      </div>

      <!-- Insert a stopover between this row and the next one -->
      @if (!last) {
        <div class="flex justify-center">
          <button
            type="button"
            class="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-700"
            (click)="this.transportFormService.insertAirportAt(i + 1)"
            data-testid="airport-transit-input-p"
          >
            <i class="pi pi-plus-circle"></i>
            {{ "calculator.transit" | transloco }}
          </button>
        </div>
      }
    }
  </div>
</section>
